import React, { useState, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faMinusCircle,
  faPlusCircle,
  faWrench,
  faTrash,
  faFileMedical,
} from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import Desfecho from "../../components/Desfecho/index.jsx";
import { SessionManager } from "../../utils/functions";
import api from "../../services/client/api";
export default function ListReportsUnimed({
  reports,
  token,
  username,
  showWithoutOutcome,
  refreshReports,
}) {
  const [expanded, setExpanded] = useState(false);
  const [showDesfecho, setShowDesfecho] = useState(false);
  const [desfechoAction, setDesfechoAction] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const [downloading, setDownloading] = useState(null);
  const [reportToDelete, setReportToDelete] = useState(null);

  const session = SessionManager();

  const openConfirmDelete = (report) => {
    setReportToDelete(report);
    setConfirmModal(true);
  };

  const handleRemove = async () => {
    if (!reportToDelete) return;

    try {
      const payload = {
        CodRequisicao: reportToDelete.CodRequisicao,
        username: username,
      };

      const response = await api().user().deleteDesfecho(token, payload);

      if (response.status === 200) {
        setConfirmModal(false);
        setReportToDelete(null);
        await refreshReports();
      }
    } catch (error) {
      console.error("Erro ao remover:", error);
    }
  };

  const download = useCallback(
    async (numberReport, typeReport) => {
      setDownloading(numberReport);

      try {
        const response = await api()
          .report()
          .downloadUnimed(token, numberReport, typeReport);

        if (response.status === 401) {
          return session.logoff();
        }

        if (response.status === 200) {
          window.open(response.output);
        }
      } catch (error) {
        console.error("Erro no download:", error);
      } finally {
        setDownloading(null);
      }
    },
    [session, token],
  );

  if (!reports || reports.length === 0) return null;

  const mainReport = reports[0];
  const hasMore = reports.length > 1;

  const openDesfecho = (report, action) => {
    setShowDesfecho(true);
    setDesfechoAction(action);
  };

  const handleCloseDesfecho = () => {
    setShowDesfecho(false);
  };

  const formatDateBR = (date) => {
    if (!date) return "";

    const dateString = String(date).split("T")[0];

    const [year, month, day] = dateString.split("-");

    if (!year || !month || !day) return "";

    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <Modal
        isOpen={confirmModal}
        toggle={() => setConfirmModal(!confirmModal)}
      >
        <ModalHeader toggle={() => setConfirmModal(!confirmModal)}>
          Confirmar exclusão
        </ModalHeader>

        <ModalBody style={{ textAlign: "center" }}>
          <b>Tem certeza que deseja remover o desfecho?</b>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={() => setConfirmModal(false)}>
            Cancelar
          </Button>

          <Button color="danger" onClick={handleRemove}>
            Remover
          </Button>
        </ModalFooter>
      </Modal>
      {/* Linha principal */}
      <tr>
        <td style={{ textAlign: "center" }}>
          {hasMore && (
            <FontAwesomeIcon
              icon={expanded ? faMinusCircle : faPlusCircle} // usa + quando fechado e − quando expandido
              color="#007DC3"
              style={{ cursor: "pointer", margin: 10, fontSize: 19 }}
              onClick={() => setExpanded(!expanded)}
              title={
                expanded
                  ? "Ocultar outros exames deste paciente."
                  : "Mostrar outros exames deste paciente."
              }
            />
          )}
        </td>

        <td style={{ textAlign: "center" }}>{mainReport.CodRequisicao}</td>

        <td style={{ textAlign: "center" }}>{mainReport.NomPaciente}</td>

        <td style={{ textAlign: "center" }}>
          {formatDateBR(mainReport.DtaSolicitacao)}
        </td>
        <td style={{ textAlign: "center" }}>
          {formatDateBR(mainReport.DtaFinalizacao)}
        </td>
        <td style={{ textAlign: "center" }}>{mainReport.DesDiagnosticoPtg}</td>

        <td style={{ textAlign: "center" }}>{mainReport.DesTopografiaPtg}</td>

        <td style={{ textAlign: "center" }}>{mainReport.NomExame}</td>

        <td style={{ textAlign: "center" }}>{mainReport.MatConvenio}</td>

        <td style={{ textAlign: "center" }}>
          {showWithoutOutcome ? (
            <Button
              color="primary"
              style={{ whiteSpace: "nowrap" }}
              onClick={() => openDesfecho(mainReport, "insert")}
            >
              <b>
                <FontAwesomeIcon
                  icon={faFileMedical}
                  style={{ marginRight: "4px" }}
                />
                Desfecho
              </b>
            </Button>
          ) : (
            <div
              style={{ display: "flex", justifyContent: "center", gap: "5px" }}
            >
              <Button
                color="primary"
                onClick={() => openDesfecho(mainReport, "update")}
              >
                <FontAwesomeIcon icon={faWrench} title={"Alterar Desfecho"} />
              </Button>

              <Button
                color="danger"
                onClick={() => openConfirmDelete(mainReport)}
              >
                <FontAwesomeIcon icon={faTrash} title={"Remover Desfecho"} />
              </Button>
            </div>
          )}
        </td>

        <td style={{ textAlign: "center" }}>
          <Button
            color="info"
            disabled={downloading === mainReport.CodRequisicao}
            onClick={() =>
              download(mainReport.CodRequisicao, mainReport.Tipo_Laudo)
            }
          >
            {downloading === mainReport.CodRequisicao ? (
              <Spinner size="sm" />
            ) : (
              <FontAwesomeIcon
                icon={faDownload}
                title={"Fazer download do Laudo"}
              />
            )}
          </Button>
        </td>
        {showDesfecho && (
          <Desfecho
            token={token}
            username={username}
            onClose={handleCloseDesfecho}
            report={mainReport}
            action={desfechoAction}
            refreshReports={refreshReports}
          />
        )}
      </tr>
      {/* Linhas expandidas */}
      {expanded &&
        reports.slice(1).map((report, index) => (
          <tr key={index} style={{ backgroundColor: "#f9f9f9" }}>
            <td style={{ textAlign: "center", paddingLeft: 10 }}></td>

            <td style={{ textAlign: "center" }}>{report.CodRequisicao}</td>

            <td style={{ textAlign: "center" }}>{report.NomPaciente}</td>

            <td style={{ textAlign: "center" }}>
              {formatDateBR(report.DtaSolicitacao)}
            </td>
            <td style={{ textAlign: "center" }}>
              {formatDateBR(report.DtaFinalizacao)}
            </td>
            <td style={{ textAlign: "center" }}>{report.DesDiagnosticoPtg}</td>

            <td style={{ textAlign: "center" }}>{report.DesTopografiaPtg}</td>

            <td style={{ textAlign: "center" }}>{report.NomExame}</td>

            <td style={{ textAlign: "center" }}>{report.MatConvenio}</td>

            <td style={{ textAlign: "center" }}>
              {showWithoutOutcome ? (
                <Button
                  color="primary"
                  style={{ whiteSpace: "nowrap" }}
                  onClick={() => openDesfecho(report, "insert")}
                >
                  <b>
                    <FontAwesomeIcon
                      icon={faFileMedical}
                      style={{ marginRight: "4px" }}
                    />
                    Desfecho
                  </b>
                </Button>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  <Button
                    color="primary"
                    onClick={() => openDesfecho(report, "update")}
                  >
                    <FontAwesomeIcon
                      icon={faWrench}
                      title={"Alterar Desfecho"}
                    />
                  </Button>

                  <Button
                    color="danger"
                    onClick={() => openConfirmDelete(report)}
                  >
                    <FontAwesomeIcon
                      icon={faTrash}
                      title={"Remover Desfecho"}
                    />
                  </Button>
                </div>
              )}
            </td>
            <td style={{ textAlign: "center" }}>
              <Button
                color="info"
                disabled={downloading === report.CodRequisicao}
                onClick={() =>
                  download(report.CodRequisicao, report.Tipo_Laudo)
                }
              >
                {downloading === report.CodRequisicao ? (
                  <Spinner size="sm" />
                ) : (
                  <FontAwesomeIcon
                    icon={faDownload}
                    title={"Fazer download do Laudo"}
                  />
                )}
              </Button>
            </td>
            {showDesfecho && (
              <Desfecho
                token={token}
                username={username}
                onClose={handleCloseDesfecho}
                report={report}
                action={desfechoAction}
                refreshReports={refreshReports}
              />
            )}
          </tr>
        ))}
    </>
  );
}
